import { type FC } from 'react'
import { Button } from '../../../../../components/Button/Button'
import { type EventTypeHost } from '../../../../../models/Scheduling'
import { HostRow } from './HostRow'
import { EmptyHostsBox, type HostsNotice, HostsList, HostsSection } from './HostsSection'

interface SingleHostSectionProps {
  host?: EventTypeHost
  disabled: boolean
  onSelect: () => void
}

const notice = (host?: EventTypeHost): HostsNotice | null =>
  host && !host.eligible ? { tone: 'warning', text: "The host can't take bookings. Clients can't book this event type." } : null

export const SingleHostSection: FC<SingleHostSectionProps> = ({ host, disabled, onSelect }) => (
  <HostsSection title='Host' subtitle='Clients can only book a host who is active and has a connected calendar.' notice={notice(host)}>
    {host ? (
      <HostsList>
        <HostRow
          host={host}
          action={
            disabled ? null : (
              <Button type='button' variant='grayButton' onClick={onSelect}>
                Replace
              </Button>
            )
          }
        />
      </HostsList>
    ) : (
      <EmptyHostsBox text="No host assigned. Clients can't book this event type." actionLabel={disabled ? undefined : 'Select a host'} onAction={onSelect} />
    )}
  </HostsSection>
)
